import { AbstractControl, ValidationErrors } from '@angular/forms';

export class PisValidator {
  static pisLengthValidator(ac: AbstractControl): ValidationErrors | null {
    return ac.value && ac.value.replace(/[^\d]/g, '').length !== 11 ? { pisInvalido: true } : null;
  }
}
